import React from 'react'
import { locationShape } from 'react-router'
import EventFormContent from './EventFormContent/EventFormContent'
import NormalCreateEvent from './NormalCreateEvent/NormalCreateEvent'
import SettingIcon from 'assets/icons/setting-icon.png'
import styles from './create-event.scss'

const CreateEventContainer = ({ location }) => {
  const queryParams = location.query || {}

  if (queryParams.design_id) {
    const image_url = decodeURIComponent(queryParams.image_url || '')
    const source = queryParams.source || 'webpage'
    const inputOptionsConfig = {
      customSettingNode: (
        <div className={styles['settings-button']}>
          <img src={SettingIcon} width="24" />
          Settings
        </div>
      ),
      showBackButton: false,
      saveButtonText: 'SAVE',
      warningText: 'Please make sure your Event Information matches your flyer',
      showTimeZoneReminder: true,
      showCheckMarkIcon: true,
      showHobnobSpace: false
    }
    return <EventFormContent
      designId={queryParams.design_id}
      imageUrl={image_url}
      source={source}
      inputOptionsConfig={inputOptionsConfig}
    />
  }

  return <NormalCreateEvent />
}

CreateEventContainer.propTypes = {
  location: locationShape
}

export default CreateEventContainer
